/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.FloorLocation {
    angular.module("meevo.plugins.floorLocation", []);
}